<template>
  <b-modal
    id="continue-with-problems"
    ref="continueWithProblemsDialog"
    class="text-left"
    :title="$t('feeding.continueWithProblems')"
  >
    <span
      v-if="!this.warning.length == 0 || !this.warning.length == 1 && this.warning[0] == 'Daten'"
    >
      {{$t('feeding.notUseable')}}
      <br />
    </span>
    <span v-if="tooHighElectricCurrent">{{$t('tooHighElectricCurrent', {feedInCurrent})}}</span>
    <template slot="modal-footer">
      <b-button @click="$refs.continueWithProblemsDialog.hide()">{{$t('cancel')}}</b-button>
      <b-button
        autofocus
        variant="danger"
        @click=" $router.push({name: 'shoppingCart', params: {projectId: $store.state.projects.project.number}})"
      >{{$t('feeding.continue')}}</b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  props: {
    warning: {
      type: Array
    },
    tooHighElectricCurrent: {
      type: Boolean
    },
    feedInCurrent: {
      type: Number
    }
  },
  methods: {
    show() {
      this.$refs.continueWithProblemsDialog.show();
    }
  }
};
</script>
